import "./ProgressStep.scss";

import { FC, ReactNode } from "react";

import Icon from "components/Icon/Icon";

import c from "classnames";

const ProgressStep: FC<ProgressStepProps> = ({ children, progress }) => {
  const classes = c("progress-step", `progress-step--${progress}`);

  const progressStepIcon = {
    completed: "CheckboxSelected",
    current: "Reset",
    upcoming: "Empty",
  }[progress];

  return (
    <div className={classes}>
      <div className="progress-step__indicator">
        <Icon src={progressStepIcon} size="sm" className="progress-step__icon" />
        <div className="progress-step__indicator-line" />
      </div>
      <div>{children}</div>
    </div>
  );
};

export default ProgressStep;

export interface ProgressStepProps {
  progress: "completed" | "current" | "upcoming";
  children?: ReactNode;
}
